// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
require('../node_modules/bootstrap-sass/assets/stylesheets/_bootstrap.scss')
require('../node_modules/font-awesome/scss/font-awesome.scss')
require('../node_modules/jszip/dist/jszip.min.js')
import App from './App'
import Vue from 'vue'
import VueRouter from 'vue-router'

//Vue.config.productionTip = false

Vue.use(VueRouter)
var root_path = ""
const router = new VueRouter({
	mode: 'history',
	routes: [{
		path:root_path + '/',
		component: require('./components/Presentation.vue')
	}, {
		path: root_path + '/ressources',
		component: require('./components/Ressources.vue')
	}, {
		path: root_path + '/processing',
		component: require('./components/Processing.vue')
	}, {
		path: root_path + '/jingle',
		component: require('./components/Jingle.vue')
	}, {
		path:'*',
		redirect: root_path + '/'
	}]
})

new Vue({
	el: '#app',
	router,
	render: h => h(require('./App.vue'))
})



// WEBPACK FOOTER //
// ./src/main.js